import styled from 'styled-components';

type ActionsType = {
  noPadding?: boolean;
};

const Container = styled.div<ActionsType>`
  display: flex;
  /* Buttons go to a new line on narrow screens instead of scrolling the page sideways. */
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  gap: 1.2rem;
  min-width: 0;

  padding-bottom: ${({ noPadding }) => (noPadding ? '0rem' : '3rem')};
`;

export { Container };
